import { Heading3, P, PrimaryCTALink, Strong } from '@ovotech/nebula';
import { format } from 'date-fns';
import React from 'react';
import { Link } from 'react-router-dom-v5';
import { Banner } from '../../Banner';
import AnalyticsWrapper from '@/src/components/AnalyticsWrapper/AnalyticsWrapper';
import {
  BANNER_CTA_CLICKED,
  LOSS_MESSAGE_SHOWN,
  MAKE_A_PAYMENT_CTA_CLICKED,
} from '@/src/constants/analytics';
import { ROUTE_MAKE_CARD_PAYMENT } from '@/src/constants/routes';
import { formatCurrencyValue } from '@/src/utils/money';

interface Props {
  bannerId: string;
  lossDate: string;
  lossEvent: string;
  balance: string;
}

export const FinalStatementReadyBalanceInDebit = (props: Props) => {
  const { bannerId, lossDate, lossEvent, balance } = props;
  const amount = formatCurrencyValue(
    {
      unit: 'GBP',
      abs: true,
      dp: 2,
    },
    { amount: balance, currencyUnit: 'GBP' },
  );

  return (
    <AnalyticsWrapper name={LOSS_MESSAGE_SHOWN} properties={{ lossEvent }}>
      <Banner icon="finalStatement" data-testid="balance-in-debit">
        <Heading3 as="h2">You've switched to a new energy supplier</Heading3>
        <P>
          Your switch happened on{' '}
          <Strong data-testid="loss-final-statement-date">
            {format(new Date(lossDate), 'Do MMMM YYYY')}.
          </Strong>
        </P>
        <P>
          As your closing account balance was in debt {amount}, we'll continue
          collecting your Direct Debit until this is cleared. If you prefer, you
          can make a top-up payment into your online account to clear the
          balance.
        </P>
        <P>
          <PrimaryCTALink
            as={Link}
            data-event-name={BANNER_CTA_CLICKED}
            data-event-props={JSON.stringify({
              bannerId: `${bannerId}-balanceInDebit`,
              ctaName: MAKE_A_PAYMENT_CTA_CLICKED,
              lossEvent,
            })}
            to={ROUTE_MAKE_CARD_PAYMENT}
          >
            Make an online payment
          </PrimaryCTALink>
        </P>
      </Banner>
    </AnalyticsWrapper>
  );
};
